export const FETCH_USERS_ERROR = 'FETCH_USERS_ERROR'

export const RECEIVE_USERS_ERROR = 'RECEIVE_USERS_ERROR'

export const RESET_USERS_ERROR = 'RESET_USERS_ERROR'

export const FETCH_USERS = 'FETCH_USERS'

export const RECEIVE_USERS = 'RECEIVE_USERS'

export const FETCH_USERS_RESET_PASSWORD_SENT_EMAIL =
  'FETCH_USERS_RESET_PASSWORD_EMAIL'

export const RECEIVE_USERS_RESET_PASSWORD_SENT_EMAIL =
  'RECEIVE_USERS_RESET_PASSWORD_EMAIL'

export const FETCH_USERS_RESET_PASSWORD = 'FETCH_USERS_RESET_PASSWORD'

export const RECEIVE_USERS_RESET_PASSWORD = 'RECEIVE_USERS_RESET_PASSWORD'

export const RECEIVE_USERS_REGISTER_DATA = 'RECEIVE_USERS_REGISTER_DATA'

export const RECEIVE_USERS_REGISTER_ID = 'RECEIVE_USERS_REGISTER_ID'
